define("main", ["jquery", "swiper", "bodyScrollLock", "focuspoint", "lazysizes"], function ($, Swiper, bodyScrollLock) {
  $(function () {
    $('.navigation-content .mobile-nav-hamburger').click(function (e) {
      if ($(this).hasClass('nav-open') && !$('#mainNavigation').hasClass('collapsing')) {
        $(this).removeClass("nav-open");
        $(this).removeClass("close");
        $(this).find("use").attr("href", "#hamburger-icon");
        $(this).attr("style", "");
      } else {
        $(this).addClass("nav-open");
        $(this).addClass("close");
        $(this).attr("style", "margin-right: -5px;");
        $(this).find("use").attr("href", "#close-icon");
      }
    });

    //main-menu hamburger and navigation
    $('.main-header .hamburger').click(function () {
      $(this).toggleClass('is-active');
    });
    $('.page-navigation .openclose').click(function () {
      $(this).toggleClass('active');
    });

    $('#mainMobileNavigation .nav-link.trigger').on('click', function (e) {
      e.preventDefault();
      $('.main-nav').addClass('active');
      $(this).closest('ul').find('.slide-in').removeClass('slide-in').removeClass('last');
      $(this).closest('ul').find('.nav-link.active').removeClass('active');
      $(this).addClass('active').parents('.last').removeClass('last');
      $(this).addClass('active').next().addClass('slide-in').addClass('last');
      if (!$(this).parents('.main-nav').find('.nav-level').hasClass('slide-in')) {
        $('.main-nav').removeClass('active');
        $('.flyout-wrapper').addClass('last');
      }
    });

    if ($(window).width() < 992) {
      $('.nav-level .back').click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).parent().parent().parent('.slide-in').find('.slide-in.last').removeClass('slide-in').removeClass('last');
        $(this).parent().parent().parent('.slide-in').removeClass('slide-in').removeClass('last');
        $(this).parents('.slide-in:first').addClass('last');
        $('.main-nav').removeClass('active');
        if (!($(this).parents('.level-2').length)) {
          $('.flyout-wrapper').addClass('last');
        }
      });
    }

    function fixPosition(reset = false) {
      if (reset) {
        $(document).off('scroll');
      } else {
        $(document).on('scroll', function() {
          $(this).scrollTop(0);
        });
      }
    }

    function setMenuHeight() {
      let vh = window.innerHeight;
      $('.flyout-wrapper').height(vh-55); // - Mobile header height
    }

    function closeAllCollapse() {
      $('[id^=mainNavigation]').each(function (index, item) {
        if ($(this).hasClass("show")) {
          $(this).collapse('toggle');
        }
      });
    }

    $('[id^=mainNavigation]').on('show.bs.collapse', function (e) {
      if ($(this).is(e.target) && $(this).data("parent") === '#HeaderMainNavigation') {
        $(this).parents('.main-header').addClass('active');
        closeAllCollapse();
        fixPosition();
      }
    });

    $('[id^=mainMobileNavigation]').on('show.bs.collapse', function (e) {
      if ($(this).is(e.target) && $(this).data("parent") === '#MobileNavigation') {
        setMenuHeight();
        fixPosition();
      }
    });

    $('[id^=mainMobileNavigation]').on('hide.bs.collapse', function (e) {
      if ($(this).is(e.target) && $(this).data("parent") === '#MobileNavigation') {
        fixPosition(true);
      }
    });

    $('[id^=mainNavigation]').on('hide.bs.collapse', function (e) {
      if ($(this).is(e.target) && $(this).data("parent") === '#HeaderMainNavigation') {
        const uid = $(this).attr("id").replace('mainNavigation', '');
        $('[data-prevlevel='+uid+']').each(function(index, item) {
          if ($(this).data('uid')) {
            let slideUid = $(this).data('uid');
            let selector = $("#subpage-slide"+slideUid);
            if (selector.hasClass('open')) {
              selector.animate({
                width: '-=100%'
              }, function(){
                $(this).removeClass("open");
              });
              $("#mainNavigationWrapper"+uid).animate({
                opacity: 1
              }, 500);

              $('#subpage-slide'+slideUid).attr('hidden', '');
            }
          }
        });
        $(this).parents('.main-header').removeClass('active');
        fixPosition(true);
      }

    });

    $(window).resize(function () {
      if ($(window).width() < 992) {
        setMenuHeight();
      }
    });

    $("[id^=mainNavigation] .close-icon").on('click', function (e) {
      closeAllCollapse();
    });

    $(".toggle-sub-navigation").on('click', function (e) {
      e.preventDefault();

      const uid = $(this).data('uid');
      const prevUid = $(this).data('prevlevel');

      $('#subpage-slide'+uid).removeAttr('hidden');

      if ($(this).hasClass("open") === false) {
        $("#mainNavigationWrapper"+prevUid).animate({
          opacity: 0
        }, 500);

        $("#subpage-slide"+uid).animate({
          width: '+=100%'
        }, function(){
          $(this).addClass("open");
          $("#subpage-slide"+uid).height($('.flyout-content'+uid).height());
        });
      }
    });

    $('.nav-link-disabled').click(function (e) {
      e.preventDefault();
    });

    $('.nav-level-back .back').click(function (e) {
      e.preventDefault();
      e.stopPropagation();

      const uid = $(this).data('back');
      const prevUid = $(this).data('prevlevel');

      $("#subpage-slide"+uid).animate({
        width: '-=100%'
      }, function(){
        $(this).removeClass("open");
      });

      $("#mainNavigationWrapper"+prevUid).animate({
        opacity: 1
      }, function () {
        $('#subpage-slide'+uid).attr('hidden', '');
      });
    });

    $(document).mouseup(function(e)
    {
      var container = $("[id^=mainNavigation]");
      var containerMainHeader = $(".main-header");
      if ((!container.is(e.target) && container.has(e.target).length === 0) && (!containerMainHeader.is(e.target) && containerMainHeader.has(e.target).length === 0) && container.hasClass('show'))
      {
        $('[id^=mainNavigation]').each(function (index, item) {
          if ($(this).hasClass("show")) {
            $(this).collapse('toggle');
          }
        });
      }
    });

    $('.focuspoint').focusPoint();
    $('.focuspoint').parents('.fade').on('focused', function () {
      $(this).addClass('show');
    });
    $('.modal').on('show.bs.modal', function (event) {
      bodyScrollLock.disableBodyScroll($('.modal-body')[0]);
      if ($(window).width() < 769) {
        $('body,html').addClass('overflow-hidden');
      }
    });
    $('.modal').on('hidden.bs.modal', function (event) {
      bodyScrollLock.enableBodyScroll($('.modal-body')[0]);
      $('body,html').removeClass('overflow-hidden');
    });

    $('a.searchBtn').on('click', function (event) {
      event.preventDefault();
      $('#searchOverlay').addClass('open');
      $('#searchOverlay > form > input[type="search"]').focus();
    });

    $('#searchOverlay, #searchOverlay button.close').on('click keyup', function (event) {
      if (event.target === this || event.target.className === 'close' || event.keyCode === 27) {
        $(this).removeClass('open');
      }
    });
  });

  let relax;

  window.checkQ = function (e) {
    if (window.jQuery && typeof window.jQuery.fn.adjustFocus === 'function') {
      setTimeout(function () {
        if (typeof window.jQuery.fn.adjustFocus === 'function') {
          window.jQuery(e.target).parents('.focuspoint').adjustFocus();
          setTimeout(function () {
            if (!$('.focuspoint').parents('.fade').hasClass('show')) {
              $('.focuspoint').parents('.fade').trigger('focused');
            }
          }, 100);
        }
      }, 450);
    } else {
      window.setTimeout("checkQ(e);", 100);
    }
  };

  function interceptLink(e) {
    if(e.shiftKey || e.ctrlKey) {
      return true;
    }
    e.preventDefault();
    var $elem = $(this);
    var href = $elem.attr('href');
    if ($elem.attr('data-toggle')) {
      return;
    }
    var hashPos = href.indexOf("#");
    if (hashPos >= 0) {
      if (hashPos === 0 || window.location.href == href.slice(0,hashPos) || window.location.href == href) {
        if (href === '#') {
          return;
        } else {
          var data = href.split('#');
          var navigateto = data.pop();
          if(href.length) {
            $('html,body').animate({
              "scrollTop": $('#'+navigateto).offset().top - 180
            }, 250);
          }
          return;
        }
      } else {
        location.href = href;
      }

    }
    location.href = href;
  }

  debounce = function (func, wait = 1000) {
    var timeout;
    return function () {
      var context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        timeout = null;
        func.apply(context, args);
      }, wait);
    };
  };

  doscroll = function () {
    $('#flyout-menu').css('height', '');
    element = $('#flyout-menu')[0];
    if (element.scrollHeight > element.clientHeight + 10 && $(window).width() > 1262) {
      $(element).height(element.clientHeight);
    }
  };

  dobreadcrumb = function () {
    const breadcrumbCount = $('#breadcrumb').attr('data-count');
    const showItems = window.innerWidth >= 768 ? 4 : 1;
    if (breadcrumbCount > showItems && breadcrumbCount !== 1) {
      $('#breadcrumb .breadcrumb-item.dots-wrap').addClass('d-flex');
    } else {
      $('#breadcrumb .breadcrumb-item.dots-wrap').removeClass('d-flex');
    }
    $('#breadcrumb .breadcrumb-item.inlist').each(function (index, item) {
      let level = $(item).attr('data-level');
      let subItemsCount = $('#breadcrumb .breadcrumb-item').find('.subitems-'+level).find('.dropdown-item').length;

      if (level <= (breadcrumbCount - showItems)) {
        $(item).addClass('d-none');
      } else {
        $(item).removeClass('d-none');
      }

      if (subItemsCount === 0) {
        $(item).find('.ems-svg-icon').addClass('d-none');
      }
    });
  };

  closeMenu = function () {
    $('.nav-item.level-1 .collapse.show').collapse('hide');
  };

  dorellax = function () {
    relaxed = $('.main-container').children().last();
    if (!relaxed.length) {
      relaxed = $('.header-content').children().last();
    }
    scrollHeight = document.body.scrollHeight;
    fHeight = $('.main-footer').height();
    if (relaxed.length && (scrollHeight - window.innerHeight) > fHeight) {
      document.documentElement.style.setProperty('--foot', window.innerHeight - fHeight - 72 + 'px');
      if (!$('.main-footer').hasClass('rellax')) {
        $('.main-footer').addClass('rellax');
        relax = new Rellax('.rellax', {
          center: true
        });
      }
    }
  };

  level2compute = function (element) {
    document.documentElement.style.setProperty('--h4h', 'auto');
    hemax = 0;
    $(element).find('.level-2 > .nav-link').each(function (hi, he) {
      if (he.clientHeight > hemax) {
        hemax = he.clientHeight;
      }
    });
    document.documentElement.style.setProperty('--h4h', hemax + 'px');
    document.documentElement.style.setProperty('--bdl', $(element).find('.level-2').length / 4);
    $(element).find('.l2-wrap').each(function (idx, we) {
      $(we).addClass('delay-l2-' + idx);
    });
  };

//global handler

  $(document).on('shown.bs.collapse', '.main-header', function (e) {
    if (e.target.id === 'service-nav') {
      $('#mainnav').scrollTop($('#mainnav')[0].scrollHeight);
    }
    if (($(e.target).hasClass('submenu-item') && $(window).width() > 1262) || (e.target.id === 'mainnav')) {
      $('body').addClass('overflow-hidden');
      $('.main-header,.page-overlay').addClass('show');

      if ($('#flyout-menu.show').length) {
        bodyScrollLock.disableBodyScroll(document.querySelector('#flyout-menu'), {
          allowTouchMove: el => {
            return true;
          },
        });
        //} else if() {
        //bodyScrollLock.disableBodyScroll(document.querySelector('.collapsing-wrapper'));
      } else {
        bodyScrollLock.disableBodyScroll(document.querySelector('#mainnav'), {
          allowTouchMove: el => {
            return true;
          },
        });
      }
      if ($(e.target).hasClass('submenu-item')) {
        document.documentElement.style.setProperty('--lasth', $(e.target).height() + 'px');
        $(e.target).addClass('opened');
      }
    }
  });

  $(document).on('hidden.bs.collapse', '.main-header', function (e) {
    if (($(e.target).hasClass('submenu-item') && $(window).width() > 1262) || (e.target.id === 'mainnav')) {
      if (!$('#flyout-menu.show').length) {
        bodyScrollLock.enableBodyScroll(document.querySelector('#mainnav'));
        bodyScrollLock.enableBodyScroll(document.querySelector('#flyout-menu'));
        $('body').removeClass('overflow-hidden');
        $('.main-header,.page-overlay').removeClass('show');
      }
      if ($(e.target).hasClass('submenu-item')) {
        $(e.target).removeClass('opened');
      }
    }
  });

  $('.btn-submit').on('click', function (e) {
    e.stopPropagation();
  });

//mobilesearch handler

  touchprevent = function (e) {
    e.preventDefault();
    $(e.target).focus().select().click();
  };

  $(document).on('show.bs.collapse', '#searchInputMob', function (e) {
    e.stopPropagation();
    $('.hamburger-wrapper,.main-header').addClass('show');
    $('.hamburger').addClass('is-active').one('click.closesearch', function (f) {
      f.stopPropagation();
      f.preventDefault();
      $('#searchInputMob').collapse('hide');
    });
  });

  $(document).on('hide.bs.collapse', '#searchInputMob', function (e) {
    e.stopPropagation();
    $('.togsearch').removeClass('d-none');
    $(this).val('');
    $('.hamburger-wrapper').removeClass('show');
    if (!$('#mainnav').hasClass('show')) {
      $('.hamburger').removeClass('is-active');
      $('.main-header').removeClass('show');
    }
  });

  $(document).on('click', '.togsearch', function () {
    $(this).addClass('d-none');
    myinput = $(this).parents('form').find('.search-box');
    myinput.val('').collapse('show');
    var e = new Event('focusme');
    myinput.on('focusme', touchprevent);
    myinput[0].dispatchEvent(e);
  });

  $(document).on('click', '.closelevel', function () {
    if (!$('.sublevel-wrap.moved-left').length) {
      $('.moved-left').removeClass('moved-left');
      $('.hamburger-wrapper,.closelevel').removeClass('show');
      $('.m-search').removeClass('hide');
      $('.show', '#flyout-menu').collapse('hide');
    } else {
      $('.moved-left').removeClass('moved-left');
    }
  });

  $(document).on('click.hamburger', '.hamburger', function (e) {
    $(this).toggleClass('is-active');
    $('.level-trigger').on('click.sublevel', function (f) {
      f.preventDefault();
      f.stopPropagation();
      $(f.delegateTarget).next('.nav').addClass('moved-left');
      $(f.delegateTarget).parents('.submenu-item').addClass('moved-left');
    });
    $('.moved-left').removeClass('moved-left');
    $('.closelevel').click();
  });

  $(document.body).on('click', function (e) {
    if (!$(e.target).parents('form').length && $('#searchInputMob').hasClass('show')) {
      $('.hamburger').trigger('click.closesearch');
    }
  });

//flyout handler

  $(document).on('hide.bs.collapse', '.collapsing-wrapper', function (e) {
    $('[data-target="#' + e.target.id + '"]').removeClass('active');
    $('#flyout-menu').css('height', '');
  });

  $(document).on('shown.bs.collapse', '.collapsing-wrapper', function (e) {
    level2compute(e.target);
    $('.main-header,#flyout-menu').addClass('show');
    $('#flyout-menu .show').find('.animate').each(function (idx, elm) {
      $(elm).addClass('animated').addClass($(elm).data('animate'));
    });
  });

  $(document).on('hidden.bs.collapse', '.collapsing-wrapper', function (e) {
    if (!$('#flyout-menu .collapsing').length && !$('#flyout-menu .show').length) {
      $('#flyout-menu').removeClass('show');
    }
    if (!$('.hamburger').hasClass('is-active') && !$('#flyout-menu.show').length) {
      $('.hamburger-wrapper,.main-header,.closelevel').removeClass('show');
    }
  });

  $(document).on('show.bs.collapse', '.collapsing-wrapper', function (e) {
    $('#flyout-menu').find('.animate').each(function (idx, elm) {
      $(elm).removeClass('animated').removeClass($(elm).data('animate'));
    });
    $('[data-target="#' + e.target.id + '"]').addClass('active');
    //show backlin
    if ($('.hamburger').hasClass('is-active')) {
      $('.m-search').addClass('hide');
      $('.hamburger-wrapper,.closelevel').addClass('show');
    }
  });

  $('.clearinput').on('click', function () {
    $(this).closest('form').find('.form-control').focus();
  });

  $(document.body).on('click', function (ev) {
    if (!$(ev.target).parents('#flyout-menu,#mainnav,.hamburger-wrapper-in').length) {
      //$('.show','#flyout-menu').collapse('hide');
      $('#flyout-menu').removeClass('show');
      if (!$(ev.target).parents('.search-box').length) {
        $('#searchInput').val('');
      }
    }
  });

  $(document).on('click', '.close-flyout', function () {
    //$('.show','#flyout-menu').collapse('hide');
    $('#flyout-menu').removeClass('show');
  });

  $('#flyout-menu').on('transitionend', function () {
    if (!$(this).hasClass('show')) {
      $('.show', '#flyout-menu').collapse('hide');
    }
  });

  $(document).on('shown.bs.dropdown', '.institutes', function (e) {
    //$('#flyout-menu .show').collapse('hide');
    $('#flyout-menu').removeClass('show');
    $('.header-overlay,.main-header').addClass('show');
    if ($(window).width() < 769) {
      $('body').addClass('overflow-hidden');
      bodyScrollLock.disableBodyScroll($('.main-header')[0], {
        allowTouchMove: el => {
          return true;
        },
      });
    }
    drop = $('.institutesdrop');
    drop.height(drop[0].offsetHeight);
  });

  $(document).on('hide.bs.dropdown', '.institutes', function () {
    $(this).height('auto');
    $('.header-overlay,.main-header').removeClass('show');
    if ($(window).width() < 769) {
      $('body').removeClass('overflow-hidden');
      bodyScrollLock.enableBodyScroll($('.main-header')[0]);
    }
  });
  $('.langselector').on('shown.bs.dropdown', function () {
    $('.main-header').one('mouseleave', function () {
      $('.main-header .langdropdown.show').removeClass('show');
    });
  });


//invert header
//   if ($('.tx-cs2-heroheader').length) {
//     $('body').addClass('unmoved');
//   }
  if ($('.tx-cs2-heroheader.invertheader').length) {
    $('body').addClass('inverted');
  }
  $('#translationnote').on('notranslation', function () {
    $('#translationnote').modal('show');
  });

  $(function () {
    $('.focuspoint').focusPoint();
    $('.focuspoint').parents('.fade').on('focused', function () {
      $(this).addClass('show');
    });

    // $('.modal').on('show.bs.modal', function (event) {
    //       bodyScrollLock.disableBodyScroll($('.modal-body')[0]);
    //       if($(window).width() < 769) {
    //         $('body,html').addClass('overflow-hidden');
    //       }
    // });
    // $('.modal').on('hidden.bs.modal', function (event) {
    //       bodyScrollLock.enableBodyScroll($('.modal-body')[0]);
    //       $('body,html').removeClass('overflow-hidden');
    // })

    //dorellax();
    dobreadcrumb();
  });

  var scpos = 0;
  doscrollnavigation = function () {
    var current = $(window).scrollTop();
    var width = $(window).width();
    var scrollHeight = document.body.scrollHeight;
    var totalHeight = window.scrollY + window.innerHeight;
    var tmr;

    if (totalHeight < scrollHeight) {
      if (current > 0 && current > scpos && !$('.hamburger.is-active').length) {
        clearTimeout(tmr);
        //$('.main-header').addClass('hideme');
        $('.main-header .langdropdown.show').removeClass('show');
        if ($(window).width() < 769) {
          $('body').removeClass('inverted');
        }
      } else {
        $('.main-header').removeClass('hideme').addClass('show');
        if ($('.tx-cs2-heroheader.invertheader').length) {
          $('body').addClass('inverted');
          if (current === 0) {
            $('.main-header').removeClass('show');
          }
        }
      }
      scpos = current;
    }
  };

  //$(window).on('scroll.navigation',doscrollnavigation);

  // $(window).on('scroll', function() {
  //   let metaNav = $('.metanavigation-wrap');
  //   if ($(window).scrollTop() >= $('.main-wrapper').offset().top + $('.main-wrapper').outerHeight() - window.innerHeight) {
  //     if (!$(metaNav).hasClass('position-absolute')) {
  //       $(metaNav).addClass('position-absolute');
  //     }
  //   } else if ($(metaNav).hasClass('position-absolute')) {
  //     $(metaNav).removeClass('position-absolute');
  //   }
  // });

  $('.breadcrumb-item').on('show.bs.dropdown', function (e) {
    submenu = $(e.target).find('.dropdown-menu');
    pos = $(e.target).position();
    mask = $(e.target).find('.mask');
    minw = $(e.target).outerWidth(true);
    maxw = '100%';
    wd = 'auto';
    sl = $('#breadcrumb')[0].scrollLeft;
    left = pos.left;
    if ($(window).width() < 769) {
      minw = 'auto';
      wd = '100%';
      left = 0;
    }
    mask.css({
      left: e.target.offsetLeft - sl + 1,
      width: e.target.clientWidth - 1,
      top: pos.top + e.target.offsetHeight - 6
    });
    submenu.css({width: wd, maxWidth: maxw, minWidth: minw, top: pos.top + e.target.offsetHeight, left: left});
  });

  $(document).on('click.intercept', 'a:not(.char-btn,.dropdown-item,.pagination-link,.anchor-link,[data-toggle],[target="_self"],[target="_blank"],[href^="tel:"],[href^="mailto:"],[href^="sms:"],[href^="javascript:"])', interceptLink);

  dotasks = debounce(function () {
    closeMenu();
    dobreadcrumb();
  }, 500);

  document.addEventListener('lazybeforeunveil', function (e) {
    window.checkQ(e);
  });

  if (window.location.hash && $(window.location.hash).length) {
    $('html,body').animate({
      "scrollTop": $(window.location.hash).offset().top - 100
    }, 250);
  }

  $(".mobile-menu-toggle").on('click', function () {
    $(this).toggleClass('open');
    $('.navbar-expand-md').toggleClass('active');
    //$(`#${$(this).attr('data-toggle')}`).toggleClass('show');
  });

  // Mobile - Solr Search Filter

  $('.search-wrap .open-search-filter').on('click', function (event) {
    event.preventDefault();
    $("#filtersContainer").addClass("fade-in").fadeIn("slow");
  });

  $('.facet-area-mobile .close-search-filter').on('click', function (event) {
    event.preventDefault();
    const selector = $("#filtersContainer");
    selector.removeClass("fade-in").addClass("fade-out");
    selector.fadeOut("slow", function() {
      $("#filtersContainer").removeClass("fade-out");
    });
  });
});
